<template>
	<div class="container">
		<!-- パンくずリスト -->
		<div class="breadcrumb_list">
			<ul>
        <!-- Top -->
        <li>
					<a v-on:click="clickLinkTop()"
           class="pointer_bt">
						<!-- font awesome -->
            <i class="fas fa-home"></i>
          </a>
				</li>
        <!-- カテゴリー※リンク先はカテゴリーの一番左に表示しているサブカテゴリページ -->
        <li v-if="this.categoryid">
          <a v-on:click="clickLinkCategory()"
            class="pointer_bt">
            <CreateplusMessage fcontId="1" v-bind:flinkId="this.selectedCategoryNumber.toString()" msgkey="1" />
          </a>
				</li>
        <!-- サブカテゴリ― -->
        <li v-if="this.subcategoryid">
          <span v-if="!this.templateid">
            <CreateplusMessage fcontId="2" v-bind:flinkId="this.selectedSubCategoryNumber.toString()" msgkey="1" />
          </span>
          <a v-else v-on:click="clickLinkSubCategory()"
            class="pointer_bt">
            <CreateplusMessage fcontId="2" v-bind:flinkId="this.selectedSubCategoryNumber.toString()" msgkey="1" />
          </a>
        </li>
        <!-- テンプレート -->
        <li v-if="this.templateid">
          {{ this.templateid }}
          <!-- <CreateplusMessage fcontId="3" v-bind:flinkId="this.selectedTemplateNumber.toString()" msgkey="1" v-bind:defaultValue="this.templateid" /> -->
        </li>
        <!-- 使い方ガイド -->
        <li v-if="this.otherpages === 'guide'">
          <CreateplusMessage fcontId="0" flinkId="1" msgkey="12" />
        </li>
			</ul>
		</div>
		<!-- /パンくずリスト -->
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CreateplusMessage from "./CreateplusMessage";
export default {
  name: "CreatePlusBreadcrumbs",
  props: {
    categoryid: String,
    subcategoryid: String,
    templateid: String,
    otherpages: String,
  },
  components: {
    CreateplusMessage,
  },
  computed: {
    ...mapState(["setupnavi", "languageChangeCount", "lg2"]),
    ...mapState('createplusTemplates', ['createplusCategories', 'createplusCategoriesStatus', 'createplusTemplates', 'createplusTemplatesStatus']),
    ...mapGetters(["isBuiltInApp"]),
    ...mapGetters('createplusTemplates', ["getSortSubCategories"]),

    selectedCategoryNumber: function () {
      if (!this.categoryid) {
        return null;
      }
      const category = this.createplusCategories.find(category => category.categoryID === this.categoryid);
      return (category || {}).categoryNumber;
    },
    selectedSubCategoryNumber: function () {
      if (!this.subcategoryid) {
        return null;
      }
      const category = this.createplusCategories.find(category => category.categoryID === this.categoryid);
      const subcategory = category.subCategories.find(subcategory => subcategory.subCategoryID === this.subcategoryid);
      return (subcategory || {}).subCategoryNumber;
    },
    selectedTemplateNumber: function () {
      if (!this.templateid) {
        return null;
      }
      const template = this.createplusTemplates.find(template => template.templateID === this.templateid);
      return (template || {}).templateNumber;
    }
  },
  methods: {
    clickLinkTop: function () {
      this.$gtag.event("tap_button", {
        "custom_parameter1": "bread_list",
        "custom_parameter2": "createtop"
      })
      if (this.isBuiltInApp) {
        this.$router.push({ 
          path: "/createplus/" + this.lg2 + "/app",
          query: { EXE: this.$route.query.EXE, LOG: this.$route.query.LOG, locale: this.$route.query.locale }
        });
      } else{
        this.$router.push({ 
          path: "/createplus/" + this.lg2 + "/",
          query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
         });
      }
    },
    clickLinkCategory: function () {
      this.$gtag.event("tap_button", {
        "custom_parameter1": "bread_list",
        "custom_parameter2": this.categoryid
      })
      let subCategories = this.getSortSubCategories(this.categoryid)
      const subcategoryid = subCategories[0].subCategoryID;
      if (this.isBuiltInApp) {
        this.$router.push({ 
          path: "/createplus/" + this.lg2 + "/app/templates/" + this.categoryid + "/" + subcategoryid,
          query: { EXE: this.$route.query.EXE, LOG: this.$route.query.LOG, locale: this.$route.query.locale }
        });
      }else {
        this.$router.push({ 
          path: "/createplus/" + this.lg2 + "/templates/" + this.categoryid + "/" + subcategoryid,
          query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
        });
      }
    },
    clickLinkSubCategory: function () {
      this.$gtag.event("tap_button", {
        "custom_parameter1": "bread_list",
        "custom_parameter2": this.subcategoryid
      })
      if (this.isBuiltInApp) {
        this.$router.push({ 
          path: "/createplus/" + this.lg2 + "/app/templates/" + this.categoryid + "/" + this.subcategoryid,
          query: { EXE: this.$route.query.EXE, LOG: this.$route.query.LOG, locale: this.$route.query.locale }
        });
      }else {
        this.$router.push({ 
          path: "/createplus/" + this.lg2 + "/templates/" + this.categoryid + "/" + this.subcategoryid,
          query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
        });
      }
    }
  }
}
</script>

<style scoped>
</style>